/*
 * This file contains the routing logic of the application.
 * The routing is done using the 'react-router-component' plugin.
 * Each 'page' is a component that contains different components,
 * in this case the pages will be selector, editor and upsale
 */
import React from "react";
import Router from "react-router-component";
import "regenerator-runtime/runtime";
import PageContainer from "./app-templates/page-container";
import Selector from "./app-selector/selector-container.js";
import Editor from "./app-editor/editor-container.js";
import Upsale from "./app-upsale/upsale.js";
import EditorOutput from "./editor-output";
import Finished from "./finished";
import LoadingApp from "./loading-app";
import ProductApi from "../utils/product-api";
import ProductCalculations from "../utils/product-calculations";
import AlbelliApi from "../utils/albelli-api";
import ProductActions from "../actions/product-actions.js";
import UserActions from "../actions/user-actions.js";
import BootstrapError from "./bootstrap-error";
import TranslateHelper from "./translate-helper";
import Config from "../config";
import createReactClass from "create-react-class";
import AdobeAnalytics from "../utils/adobe-analytics";
import { Logger, IntervalTransporter, ConsoleTransporter } from "@albelli/logging-frontend-client";
import CampaignDiscount from '@albelli/discounts-campaignproductdisplayclient';
// import "@albelli/arc-3/lib/core.css";
import "../../preprocessor/sass/index.scss";

var DetectBrowser = require("detect-browser");
var Jso = require("jso");

var Location = Router.Location;
var Locations = Router.Locations;
var browser = DetectBrowser.detect();

//window.Perf = require('react-addons-perf'); //Enable this to be able to write Perf.start() and Perf.stop() and Perf.printWasted() in the console. This will measure how much time is wasted on unneccassary updating of compontents doing the actions you did between start and stop
import lang from "../../language";
import logActions from "../actions/log-actions";
import { dynatraceRequestAdapter } from "../utils/dynatraceRequestAdapter";
require("blueimp-canvas-to-blob"); //Polyfill for the native canvas.toBlob method
require("sticky");

global._ = lang;
global.Debug = logActions;

/* Initialize logger before React loads */
(function initializeLogger() {
    if (!window["OPElogger"]) {
        var transporters = [
            new IntervalTransporter({
                interval: 3000,
                batchSize: 10,
                request: dynatraceRequestAdapter,
            }),
        ];
        if (process.env.NODE_ENV && process.env.NODE_ENV === "development") {
            transporters.push(new ConsoleTransporter());
        }
        window["OPElogger"] = new Logger(transporters);
    }
})();

var App = createReactClass({
  getInitialState: function () {
    return {
      productsLoaded: false,
      channelLoaded: false,
      bootstrapError: null,
      cookieChoiceMade: false,
    };
  },

  componentDidMount: function () {
    if (sessionStorage.getItem("theme") != "") {
      document.getElementById("app").className +=
        " theme-" + sessionStorage.getItem("theme");
    }

    const channel = sessionStorage.getItem("channel");
    const channelSuffix = channel.includes("hofmann") ? "hfm" : channel.includes("photobox") ? "pbx" : "alb";
    const link = document.getElementById("favicon");
    link.href = `assets/images/favicons/favicon-${channelSuffix}.ico`;
  },
  mapCannelToIdp: function (channel) {
    //Only Fotoknudsen has their own Idp in OAuth
    switch (channel) {
      case "fotoknudsen.no":
        return "fotoknudsen";
      default:
        return "albelli";
    }
  },

  //This will handle all bootstrapping of the application, and when done, set the state to finished so that the app will load
  componentWillMount: function () {
    var self = this;
    logToCentralServer("Application is loading", "", Config.LogLevel.INFO);

    //Validate that the app has been initiated correctly by the init.html script
    if (sessionStorage.getItem("channel") == null) {
      this.setState({ bootstrapError: "Missing channel param" });
      return;
    }

    if (!location.origin.includes("localhost")) {
      if (!location.origin.includes((sessionStorage.getItem("channel")  === "albelli.se" ) ? "onskefoto.se" : sessionStorage.getItem("channel"))) {
        this.setState({ bootstrapError: "Invalid channel param" });
        return;
      }
    }

    if (sessionStorage.getItem("theme") == null) {
      this.setState({ bootstrapError: "Missing theme param" });
      return;
    }

    if (
      !(
        sessionStorage.getItem("theme") === "fotoknudsen" ||
        sessionStorage.getItem("theme") === "albelli" ||
        sessionStorage.getItem("theme") === "bonusprint" ||
        sessionStorage.getItem("theme") === "monalbumphoto"||
        sessionStorage.getItem("theme") === "hofmann"||
        sessionStorage.getItem("theme") === "photobox"||
        sessionStorage.getItem("theme") === "posterxxl"
      )
    ) {
      this.setState({
        bootstrapError:
          "The theme parameter has a wrong value. Must be fotoknudsen, albelli, monalbumphoto, bonusprint or posterxxl",
      });
      return;
    }

    //Get the users login state
    var redirectUrl = Config.oauthRedirectUrl;
    if (window.location.port != "" && window.location.port != "0") {
      redirectUrl = redirectUrl.replace(
        "$$hostname",
        window.location.hostname + ":" + window.location.port
      );
    } else {
      redirectUrl = redirectUrl.replace("$$hostname", window.location.hostname);
    }

    var oauth2Client = new Jso.JSO({
      providerID: "albelli",
      client_id: Config.oauthClientId,
      redirect_uri: redirectUrl,
      authorization: Config.oauthAuthorizationUrl,
      debug: false,
    });

    var opts = {
      scopes: {
        request: ["openid", "storage.upload.write", "storage.upload.read"],
      },
      request: {
        prompt: "none",
        acr_values:
          "idp:" + this.mapCannelToIdp(sessionStorage.getItem("channel")),
      },
      response_type: "id_token token",
      redirect_uri: redirectUrl,
    };

    oauth2Client.setLoader(Jso.IFramePassive);

    function CookieConsent(channel) {
      const url = window.environment.cookie_consent.replace("{channel}", channel);
      const channelsWithExplicitConsent = [
        "monalbumphoto.fr",
        "posterxxl.de",
        "b2b.posterxxl.de"
    ];
      const scriptTag = document.createElement("script");
      document.head.appendChild(scriptTag);
      const cookieConsentStatus = {
        ACCEPTED: ["1", "11", "10"],
        REJECTED: "0",
      };
      scriptTag.onload = () => {
        if (
          window["enableCookieConsentModal"] &&
          typeof window["enableCookieConsentModal"] === "function"
        ) {
          window["enableCookieConsentModal"](channel, "albelli-online-editor")
            .then((userConsentChoice) => {
              if (channelsWithExplicitConsent.includes(channel)) {
                if (cookieConsentStatus.ACCEPTED.includes(userConsentChoice)) {
                  self.setState({ cookieChoiceMade: true });
                  AdobeAnalytics.setCookieConsent(true);
                  window.addEventListener("launchLoaded", function () {
                    AdobeAnalytics.setCookieConsent(true);
                  });
                } else {
                  AdobeAnalytics.setCookieConsent(false);
                  self.setState({ cookieChoiceMade: true });
                }
              } else {
                AdobeAnalytics.setCookieConsent(true);
                self.setState({ cookieChoiceMade: true });
              }
            })
            .catch((error) => {
              logToCentralServer(
                "Cookie consent error",
                error,
                Config.LogLevel.ERROR
              );
            });
        }
      };
      scriptTag.onerror = (error) => {
          AdobeAnalytics.setCookieConsent(true);
          self.setState({ cookieChoiceMade: true });
      };
      scriptTag.src = url;
    }

    //Get the ecom token if the user is logged into the website.
    function updateToken() {
      oauth2Client
        .getToken(opts)
        .then(function (token) {
          sessionStorage.setItem(
            "userToken",
            token.token_type + " " + token.access_token
          );
          UserActions.updateUserToken(
            token.token_type + " " + token.access_token
          );
          oauth2Client.wipeTokens();

          //Refresh token after it has expired
          setTimeout(
            updateToken.bind(oauth2Client, UserActions),
            token.expires_in * 1000
          );
        })
        .catch(function (err) {
          sessionStorage.setItem("userToken", "");
          oauth2Client.wipeTokens();
        });
    }

    updateToken();

    //Load channel data
    AlbelliApi.getChannelData(sessionStorage.getItem("channel"))
      .then(function (data) {
        sessionStorage.setItem("vendor", data.vendor);
        if (
          !sessionStorage.getItem("language") ||
          sessionStorage.getItem("language") === "undefined"
        ) {
          sessionStorage.setItem("language", data.language);
        }
        sessionStorage.setItem("currencySymbol", data.currency.symbol);
        sessionStorage.setItem("currencyCode", data.currency.code);
        sessionStorage.setItem(
          "currencyDecimalSeparator",
          data.currency.decimalSeparator
        );
        sessionStorage.setItem(
          "currencyThousandsSeparator",
          data.currency.thousandsSeparator
        );
        sessionStorage.setItem("currencyShowSymbol", data.currency.showSymbol);
        sessionStorage.setItem(
          "currencyZeroDecimalsReplacement",
          data.currency.zeroDecimalsReplacement
        );
        sessionStorage.setItem("showAsterisk", data.currency.showAsterisk);
        sessionStorage.setItem("description", data.currency.description);
        sessionStorage.setItem("shippingFaqUrl", data.shippingFaqUrl);

        //Check for valid browser
        switch (browser && browser.name) {
          case "samsung":
            self.setState({
              bootstrapError: _(
                "Unfortunately your browser does not support all options for creating this product. Please install Safari, Chrome, Firefox or a newer version of Internet Explorer (11 or Edge) and start again."
              ),
            });
            return;
          default:
            break;
        }

        //This uses translation for the error message, and the language may not be set earlier, so this is included after all the initialization
        //This is the warning the user gets when he tries to leave the page without completing the work
        require("../utils/leave-page-warning");
        const Usabilla = require("../../vendor/monitoring/usabilla");

        const id =
          sessionStorage.getItem("usabilla_group") === "internal"
            ? "internalId"
            : sessionStorage.getItem("channel");
        Usabilla.init(id, window.environment.usabilla);

        // Add custom data.
        if (window["usabilla_live"]) {
          window["usabilla_live"]("data", {
            custom: {
              SessionID: sessionStorage.getItem("sessionId"),
            },
          });
        }
        AdobeAnalytics.initialize();

        if (window.environment.cookie_consent_enabled === true) {
          const storedChannel = sessionStorage.getItem("channel");
          const channel = ( storedChannel === "albelli.se" ) ? "onskefoto.se" : storedChannel;
          CookieConsent(channel);
        } else {
          AdobeAnalytics.setCookieConsent(true);
          self.setState({ cookieChoiceMade: true });
        }

        self.setState({ channelLoaded: true });
      })
      .then(function () {
        //Get discounts for current campaign
        const url = location.origin.includes("localhost") ?
            "https://t-dtap." + sessionStorage.getItem("channel") :
            location.origin
                .replace("https://editor.", "https://www.")
                .replace("editor.", "")
                .replace("onskefoto.se", "albelli.se");
          const options = {
              validDetector: ["localStorage", "cookie", "param"],
              merchandisingMergeMode: "non-valid-campaign",
              apiVersion: 2,
          };
          const campaignDiscount = new CampaignDiscount(url, options);
        return campaignDiscount.getCategoryArticlesDiscount("Prints")
            ["catch"](function (error) {
                // Log warning but continue
                logToCentralServer("CampaignDiscount error", error, Config.LogLevel.WARN);
                return [];
            });
      })
      .then(function (campaignPrices) {

        //Fetch initial product data
        return ProductApi.fetchProductsBasedOnEditorModeAndVendor(
          sessionStorage.getItem("editorMode"),
          sessionStorage.getItem("vendor"),
          campaignPrices
        );
      })
      .then(function (productList) {
        if (productList.length === 0) {
          throw new Error(
            _("Unable to load any products. Perhaps they are misconfigured.")
          );
        }

        //Add all the products to the product store
        for (var i = 0; i < productList.length; i++) {
          ProductActions.addProduct(productList[i]);
        }

        //If any of the products should have upsells to other products, add the upsell here
        ProductCalculations.addUpgradeProductAsUpsell(productList);

        self.setState({ productsLoaded: true });
      })
      ["catch"](function (error) {
        displayError(error.message, error, Config.LogLevel.ERROR, 'BOOTSTRAP_ERROR');
      });
  },

  render: function () {
    if (
      this.state.productsLoaded &&
      this.state.channelLoaded &&
      this.state.cookieChoiceMade
    ) {
      return (
        <PageContainer>
          <Locations hash>
            <Location path="/" handler={Selector} />
            <Location path="/selector" handler={Selector} />
            <Location path="/editor" handler={Editor} />
            <Location path="/upsale" handler={Upsale} />
            <Location path="/output" handler={EditorOutput} />
            <Location path="/finished" handler={Finished} />
            <Location path="/translatehelper" handler={TranslateHelper} />
          </Locations>
        </PageContainer>
      );
    } else if (this.state.bootstrapError != null) {
      return <BootstrapError message={this.state.bootstrapError} />; //Show bootstrap error
    } else {
      return <LoadingApp />; //Show loading app message
    }
  },
});

//Exports the App variable so that main.js can access it
export default App;
